import { render } from "./AttractTable.vue?vue&type=template&id=2b654ee8&scoped=true"
import script from "./AttractTable.vue?vue&type=script&lang=js"
export * from "./AttractTable.vue?vue&type=script&lang=js"

import "./AttractTable.vue?vue&type=style&index=0&id=2b654ee8&scoped=true&lang=css"
import "./AttractTable.vue?vue&type=style&index=1&id=2b654ee8&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b654ee8"]])

export default __exports__